import { render, staticRenderFns } from "./ProjectWizardStep3.vue?vue&type=template&id=5f78640f"
import script from "./ProjectWizardStep3.vue?vue&type=script&lang=js"
export * from "./ProjectWizardStep3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports